"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RowSeparator = require("./RowSeparator.style");

var Separator = function Separator() {
  return _react.default.createElement(_RowSeparator.StyledSeparator, {
    className: "Separator"
  }, "/");
};

var RowSeparator = function RowSeparator(_ref) {
  var style = _ref.style,
      className = _ref.className,
      children = _ref.children;
  return _react.default.createElement(_RowSeparator.StyledWrapper, {
    style: style,
    className: className
  }, _react.default.Children.map(children, function (child, index) {
    return index ? [_react.default.createElement(Separator, null), child] : child;
  }));
};

RowSeparator.propTypes = {
  style: _propTypes.default.object,
  className: _propTypes.default.string
};
RowSeparator.defaultProps = {
  style: {},
  className: ''
};
var _default = RowSeparator;
exports.default = _default;